// extracted by css-extract-rspack-plugin
export default {"layout":"ProductFormLayout_layout__n77H_","content":"ProductFormLayout_content__PxBdm"};